export default "__VITE_ASSET__tcHX7UYx__"